import React, {useState} from 'react';
import ErrorToast from '../components/ErrorToast/ErrorToast';


export function useErrorToast(defaultState='') {
  const [errorMsg,setErrorMsg] = useState(defaultState);

  const errorToast = errorMsg && <ErrorToast close={() => setErrorMsg('')}>{errorMsg}</ErrorToast>;
  
  return {
    errorMsg,
    setErrorMsg,
    errorToast
  };
};
